/// <amd-module name="Test/TestResultDetails/Components/DetailsViewUtils" />

export class DebugViewUtils {
    static stripHtml(html: string): string{
        try{
            var doc = new DOMParser().parseFromString(html, 'text/html');
            return doc.body.textContent || "";
        }
        catch(err){
            return html;
        }
     }
}
